import { Button, Heading, Text } from "@instacover/ui"
import { createFileRoute, Link } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { useStepWithMedia } from "@/services/dexie"

import { ClientRedirect } from "../../../../components/ClientRedirect"
import { ExtraIcons } from "../../../../components/icons/InstructionImageType"
import { ImageLayout } from "../../../../components/layouts/ImageLayout"
import { SpinnerLayout } from "../../../../components/layouts/SpinnerLayout"
import { LINKS } from "../../../../routing/links"
import { useFinishStepAndNavigate, useStepsRouting } from "../../../../routing/useStepsRouting"

export const Route = createFileRoute("/$sessionId/_session/damage/add-more")({
  component: DamageAddMore,
})

function DamageAddMore() {
  const { t } = useTranslation()

  const { sessionId } = Route.useParams()
  const finishAndNavigate = useFinishStepAndNavigate(sessionId)
  const { firstUnfinishedStepLink, isLoading: stepsLoading } = useStepsRouting(sessionId)

  const { data: step, isLoading: stepLoading } = useStepWithMedia(sessionId, "Damage")

  if (stepLoading || stepsLoading) return <SpinnerLayout />

  if (!step) {
    return <ClientRedirect to={firstUnfinishedStepLink ?? LINKS.finalCheck(sessionId)} />
  }

  return (
    <ImageLayout
      iconName={ExtraIcons.DamageAddMore}
      content={
        <>
          <Heading as="h2" variant="h1">
            {t("damage.addMore.title")}
          </Heading>

          <div className="h-6 w-6 shrink-0" />

          <Text>{t("damage.addMore.text")}</Text>
        </>
      }
      footer={
        <>
          <div className="h-5 w-5 shrink-0" />

          <Button
            data-testid="damage-add-more-done-btn"
            disabled={!step.isMinMediaSatisfied}
            onClick={() => finishAndNavigate("Damage")}
          >
            {t("damage.addMore.secondaryActionTitle")}
          </Button>

          <div className="h-2 w-2 shrink-0" />

          <Link to={LINKS.damageNew(sessionId)}>
            <Button as="span" variant="secondary">
              {t("damage.addMore.primaryActionTitle")}
            </Button>
          </Link>

          <div className="h-11 w-11 shrink-0" />
        </>
      }
    />
  )
}
